const getGameType = urlParam => {
    const gameType = urlParam.split('-');
    return gameType.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join('');
};

export default getGameType;
